let currentVersion = null;

/**
 * Verifica o /version.txt e, se detectar nova versão,
 * recarrega a página ou chama um callback.
 *
 * @param {Object} options
 * @param {boolean} options.autoReload - se true, chama window.location.reload()
 * @param {(info: { currentVersion: string, newVersion: string }) => void} options.onNewVersion
 */
export async function checkVersionAndReload({ autoReload = true, onNewVersion } = {}) {
	try {
		const res = await fetch("/version.txt", {
			cache: "no-store",
		});

		if (!res.ok) {
			console.error("Não foi possível ler /version.txt");
			return;
		}

		const newVersion = (await res.text()).trim();

		// primeira vez: só guarda
		if (currentVersion === null) {
			currentVersion = newVersion;
			return;
		}

		// se mudou, dispara ação
		if (currentVersion !== newVersion) {
			if (typeof onNewVersion === "function") {
				onNewVersion({ currentVersion, newVersion });
			}

			if (autoReload) {
				window.location.reload();
			}
		}
	} catch (err) {
		console.error("Erro ao verificar nova versão:", err);
	}
}
// 👇 nova função pra só pegar a versão e usar na UI
export async function fetchAppVersion() {
	try {
		const res = await fetch("/version.txt", { cache: "no-store" });
		if (!res.ok) {
			console.error("Não foi possível ler /version.txt");
			return "";
		}
		return (await res.text()).trim();
	} catch (err) {
		console.error("Erro ao buscar versão:", err);
		return "";
	}
}
